import React from 'react';
import PropTypes from 'prop-types';
import { Input, Checkbox } from 'react-toolbox';
import TextArea from 'components/TextArea';
import S from '../TemplateStyling.scss';
import parseMeasurement from './measures/measurementParsing';

function WorkOrderDetails({ details, onChange }) {
  // Generic handler for any field
  const handleFieldChange = (field, value) => {
    onChange({ ...details, [field]: value });
  };

  return (
    <div>
      <div>
        <em>Please fill out this form completely, take photos of the door/window, exterior of home,
            entry door if Condo and any damage that occured. If windows, provide picture of Sash
            Tag.</em>
      </div>
      <div>
        <Input label="Customer Name:" value={details.customerName} onChange={v => handleFieldChange('customerName', v)} />
        <Input label="WO/Job #:" value={details.job_id} onChange={v => handleFieldChange('job_id', v)} />
        <Input
          type="date"
          label="Date of Inspection:"
          value={details.dateOfInspection || ''}
          onChange={v => handleFieldChange('dateOfInspection', v)}
        />
        <Input label="Room Name, Location:" value={details.location} onChange={v => handleFieldChange('location', v)} />
      </div>
      <div className={S.checkboxContainer}>
        <div>
          <span>Property Damage:</span>
          <Checkbox
            label="Yes"
            checked={details.propertyDamage === true}
            onChange={() => handleFieldChange('propertyDamage', true)}
            className={S.theme__check___1CXAo}
          />
          <Checkbox
            label="No"
            checked={details.propertyDamage === false}
            onChange={() => handleFieldChange('propertyDamage', false)}
            className={S.theme__check___1CXAo}
          />
        </div>
        {details.propertyDamage === true && (
          <Input
            label="If yes, please explain (Where damage occured? What was damaged? If flooring, provide sq. ft.)"
            value={details.propertyDamageExplanation || ''}
            onChange={v => handleFieldChange('propertyDamageExplanation', v)}
            required
          />
        )}
      </div>
      <div>
        <Input label="Nature of Issue:" value={details.natureOfIssue || ''} onChange={v => handleFieldChange('natureOfIssue', v)} />
        <Input label="Resolution:" value={details.resolution || ''} onChange={v => handleFieldChange('resolution', v)} />
      </div>
      <div className={S.checkboxContainer}>
        <div>
          <span>Product Required:</span>
          <Checkbox
            label="Yes"
            checked={details.productRequired === true}
            onChange={() => handleFieldChange('productRequired', true)}
            className={S.theme__check___1CXAo}
          />
          <Checkbox
            label="No"
            checked={details.productRequired === false}
            onChange={() => handleFieldChange('productRequired', false)}
            className={S.theme__check___1CXAo}
          />
        </div>
        {details.productRequired === true && (
          <Input
            label="If yes, please explain:"
            value={details.productRequiredExplanation || ''}
            onChange={v => handleFieldChange('productRequiredExplanation', v)}
            required
          />
        )}
      </div>
      <div className={S.checkboxContainer}>
        <div>
          <span>Labor Required for repairs:</span>
          <Checkbox
            label="Yes"
            checked={details.laborRequired === true}
            onChange={() => handleFieldChange('laborRequired', true)}
            className={S.theme__check___1CXAo}
          />
          <Checkbox
            label="No"
            checked={details.laborRequired === false}
            onChange={() => handleFieldChange('laborRequired', false)}
            className={S.theme__check___1CXAo}
          />
        </div>
        {details.laborRequired === true && (
          <Input
            label="If yes, please explain:"
            value={details.laborRequiredExplanation || ''}
            onChange={v => handleFieldChange('laborRequiredExplanation', v)}
            required
          />
        )}
      </div>
      <div className={S.checkboxContainer}>
        <span>Door/Window Information</span>
        <div className={S.checkboxContainer}>
          <Checkbox
            label="LH"
            checked={details.lh || false}
            onChange={v => handleFieldChange('lh', v)}
            className={S.theme__check___1CXAo}
          />
          <Checkbox
            label="RH"
            checked={details.rh || false}
            onChange={v => handleFieldChange('rh', v)}
            className={S.theme__check___1CXAo}
          />
          <Checkbox
            label="Inswing"
            checked={details.inswing || false}
            onChange={v => handleFieldChange('inswing', v)}
            className={S.theme__check___1CXAo}
          />
          <Checkbox
            label="Outswing"
            checked={details.outswing || false}
            onChange={v => handleFieldChange('outswing', v)}
            className={S.theme__check___1CXAo}
          />
        </div>
        <Input label="Color" value={details.color || ''} onChange={v => handleFieldChange('color', v)} />
        <Input label="Jamb Size" hint="e.g. 34 1/2" value={details.jambSize || ''} onChange={v => handleFieldChange('jambSize', v)} />
        <span>Door Measurements</span>
        <Input label="Door Width, frame size (prehung)" hint="e.g. 34 1/2" value={details.doorWidthFrame || ''} onChange={v => handleFieldChange('doorWidthFrame', v)} />
        <Input label="Door Height, frame size (prehung)" hint="e.g. 34 1/2" value={details.doorHeightFrame || ''} onChange={v => handleFieldChange('doorHeightFrame', v)} />
        <Input label="Door Width, slab" hint="e.g. 34 1/2" value={details.doorWidthSlab || ''} onChange={v => handleFieldChange('doorWidthSlab', v)} />
        <Input label="Door Height, slab" hint="e.g. 34 1/2" value={details.doorHeightSlab || ''} onChange={v => handleFieldChange('doorHeightSlab', v)} />
        <span>Window Information</span>
        <div className={S.checkboxContainer}>
          <Checkbox
            label="Full frame"
            checked={details.fullFrame || false}
            onChange={v => handleFieldChange('fullFrame', v)}
            className={S.theme__check___1CXAo}
          />
          <Checkbox
            label="Pocket RPL"
            checked={details.pocketRPL || false}
            onChange={v => handleFieldChange('pocketRPL', v)}
            className={S.theme__check___1CXAo}
          />
        </div>
        <Input label="Exact Frame Width" hint="e.g. 34 1/2" value={details.exactFrameWidth || ''} onChange={v => handleFieldChange('exactFrameWidth', v)} />
        <Input label="Exact Frame Height" hint="e.g. 34 1/2" value={details.exactFrameHeight || ''} onChange={v => handleFieldChange('exactFrameHeight', v)} />
      </div>
      <div>
        <TextArea label="Additional Comments:" value={details.additionalComments || ''} onChange={e => handleFieldChange('additionalComments', e.target.value)} />
      </div>
    </div>
  );
}

WorkOrderDetails.propTypes = {
  details: PropTypes.shape({
    customerName: PropTypes.string,
    job_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    dateOfInspection: PropTypes.string,
    location: PropTypes.string,
    propertyDamage: PropTypes.bool,
    propertyDamageExplanation: PropTypes.string,
    natureOfIssue: PropTypes.string,
    resolution: PropTypes.string,
    productRequired: PropTypes.bool,
    productRequiredExplanation: PropTypes.string,
    laborRequired: PropTypes.bool,
    laborRequiredExplanation: PropTypes.string,
    lh: PropTypes.bool,
    rh: PropTypes.bool,
    inswing: PropTypes.bool,
    outswing: PropTypes.bool,
    color: PropTypes.string,
    jambSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    doorWidthFrame: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    doorHeightFrame: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    doorWidthSlab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    doorHeightSlab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fullFrame: PropTypes.bool,
    pocketRPL: PropTypes.bool,
    exactFrameWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    exactFrameHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    additionalComments: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default WorkOrderDetails;

export function validateWorkOrderDetails(details) {
  const errors = {};
  const measurementFields = [
    'jambSize',
    'doorWidthFrame',
    'doorHeightFrame',
    'doorWidthSlab',
    'doorHeightSlab',
    'exactFrameWidth',
    'exactFrameHeight',
  ];
  let hasMeasurementError = false;
  measurementFields.forEach((field) => {
    const value = details[field];
    if (value !== undefined && value !== '' && isNaN(parseMeasurement(value))) {
      errors[field] = [`${field} must be a number or fraction.`];
      hasMeasurementError = true;
    }
  });
  if (hasMeasurementError) {
    errors.numberFields = [
      'Please ensure all measurement fields are valid numbers or fractions (in inches).',
    ];
  }
  if (!details.dateOfInspection) {
    errors.dateOfInspection = ['Date of Inspection is required.'];
  } else if (isNaN(Date.parse(details.dateOfInspection))) {
    errors.dateOfInspection = ['Date of Inspection must be a valid date.'];
  }
  const yesNoExplanationFields = [
    { field: 'propertyDamage', explanationField: 'propertyDamageExplanation', label: 'Property Damage' },
    { field: 'productRequired', explanationField: 'productRequiredExplanation', label: 'Product Required' },
    { field: 'laborRequired', explanationField: 'laborRequiredExplanation', label: 'Labor Required' },
  ];
  yesNoExplanationFields.forEach(({ field, explanationField, label }) => {
    if (details[field] === true && !(details[explanationField] || '').trim()) {
      errors[explanationField] = [`Please provide an explanation for ${label}.`];
    }
  });
  return errors;
}



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/WorkOrderDetails.jsx